const fontSize = {
  small: '14px',
  medium: '16px',
  large: '18px',
};

export default fontSize;
